export default __webpack_public_path__ + "static/media/instagram-blue.7b719c5b.svg";